import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, PageHeader, List, Row, Col, Icon, Button } from 'antd'

import RecordsPopup from '@components/Popup/RecordsPopup'
import EditTermCollection from '@components/Popup/EditTermCollection'
import AddTermCollection from '@components/Popup/AddTermCollection'
import TermsListPopup from '@components/Popup/TermsListPopup'
import EditTermPopup from '@components/Popup/EditTermPopup'

import Term from './Term'
import Collection from './Collection'
import Policies from './Policies'

@inject((store: any) => {
    const { collectionsStore, termsStore, popupStore } = store
    return { collectionsStore, termsStore, popupStore }
})
@observer
class CollectionTerms extends Component<any, any> {
    componentDidMount() {
        this.getTermsList()
    }

    getTermsList = async () => {
        const { id } = this.props.computedMatch.params
        this.props.termsStore.getTermsList(id)
        this.props.collectionsStore.getCollection(id)
    }

    handleLinkTerm = () => {
        this.props.termsStore.getFilteredList()
        this.props.popupStore.togglePopup('termsList')
    }

    handleAddTerm = () => {}

    render() {
        const { list, loading } = this.props.termsStore
        const { name, id, collectionPolicies } = this.props.collectionsStore.collection
        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader title={`עריכת תנאים בזכות - ${name} (${id})`} />
                <Row gutter={20}>
                    <Col xs={14}>
                        <div style={{ backgroundColor: 'white', margin: '0.5rem', padding: '1.5rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 0 1rem' }}>
                                <h5>רשימת התנאים המקושרים לזכות (נמצאו {list.length} תנאים)</h5>
                                <div>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '0rem' }}
                                        onClick={() => this.handleLinkTerm()}
                                    >
                                        <Icon type="link" />
                                        קישור תנאי חדש
                                    </Button>
                                </div>
                            </div>
                            <div style={{ paddingBottom: '2rem' }}>
                                <List
                                    dataSource={list}
                                    pagination={{
                                        hideOnSinglePage: true,
                                        pageSize: 10
                                    }}
                                    loading={loading}
                                    renderItem={item => <Term item={item} />}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={10}>
                        <div style={{ backgroundColor: 'white', margin: '0.5rem', padding: '1.5rem' }}>
                            <h5>פרטי הזכות</h5>
                            <Collection />
                        </div>
                        <div style={{ backgroundColor: 'white', margin: '0.5rem', padding: '1.5rem' }}>
                            {collectionPolicies ? (
                                <Policies collectionPolicies={collectionPolicies} />
                            ) : (
                                <Icon type="loading" />
                            )}
                        </div>
                    </Col>
                </Row>
                <RecordsPopup />
                <EditTermCollection />
                <AddTermCollection />
                <TermsListPopup />
                <EditTermPopup />
            </Layout>
        )
    }
}

export default withRouter(CollectionTerms)
